<template>
  <div class="py-4 container-fluid">
  <form ref='editForm' class="needs-validation" novalidate>
    <div class="row">
      <div class="text-right col-lg-12 d-flex justify-content-end">
        <div class="col-lg-1 p-0 text-start">
          <router-link :to="{ name: 'Brands list' }" class="p-0 back-button" title="Volver"> <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i></router-link>
        </div>
        <div class="my-auto ms-auto">
          <button type="button" class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 " @click="save()">
            Guardar
          </button>     
        </div>  
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-lg-6">
        <div class="row col-12">
            <div class="card card-height" >
              <div class="card-body">
                <h5 class="font-weight-bolder">Cliente</h5>
                <div class="row">
                  <textarea id="client_json" v-model="client.json" class="form-control" placeholder="{ json }" rows="16" required></textarea>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
            <div class="card mb-4" style="max-height: 13rem; height: 13rem;">
              <div class="card-body">
                <h5 class="font-weight-bolder">Credenciales</h5>
                <div class="row">
                  <div class="">
                    <label>Identidicador Cliente:</label>
                    <p>{{ client.credentials.idClient }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                    <label>Usuario Administrador:
                      </label>
                      <p>{{ client.credentials.user }}</p>
                  </div>
                  <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                    <label>Password:</label>
                    <div class="input-group">
                <input
                  id="current-password"
                  v-model="client.credentials.password"
                  disabled
                  :type="!icons.showCurrentPassword ? 'password' : 'text'"
                  class="form-control"
                  aria-label="Current password"
                  name="currentPassword"
                  required
                >
                <button
                  id="bn-current-password"
                  class="btn btn-outline-secondary btn-form"
                  type="button"
                  @click="icons.showCurrentPassword = !icons.showCurrentPassword"
                >
                  <i :class="{
                    'fa fa-eye-slash': !icons.showCurrentPassword,
                    'fa fa-eye': icons.showCurrentPassword,
                  }" />
                </button>
              </div>
                  </div>
                </div>
                
              </div>
            </div>
        </div>
        <div class="row">
            <tokens :client= client></tokens> 
        </div>
      </div>

    </div>
  </form>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>

</template>

<script>
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import Tokens from "./Tokens.vue";
export default {
  name: "NewEditClient",
  components: {SoftSnackbar,Tokens },
  data() {
    return {
      
      client:{
        json: '',
        credentials:{
          idClient:'',
          user:'',
          password:'',
        },
        token: ''
      },
      clienteId:null,
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      icons: {
        showCurrentPassword: false,
      },

    }
  },
  computed: {
    clienteData() {
      return this.$store.state.customer.client.data;
    },
    nuevoStatus(){
      return this.$store.state.customer.newClient.status;
    },
    editStatus(){
      return this.$store.state.customer.updateClient.status;
    },
  },
  watch:{
    clienteData(val) {
      if(val){
        this.client=this.$store.state.customer.client.data;
        this.client.json= JSON.stringify(this.client.json,null,3);
      }
    },
    nuevoStatus(value){
      if (value.created) {
        this.loadStatusNotification(this.$store.state.customer.newClient.data)
        let newClient= this.$store.state.customer.newClient.data.idClient
        if (newClient)
        {
          this.$router.push({ path: "/Administration/Brands/EditBrand/" + newClient});
          this.$store.commit("customer/getById",newClient);
        }

      }
      else if (value.error) {
        const error = value.error.error;
        let message="Ha ocurrido un error al crear el cliente";
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    editStatus(value){
      if (value.updated) {
        this.loadStatusNotification(this.$store.state.customer.updateClient.data)
        this.$router.push({ path: "/Administration/Brands/EditBrand/" + this.clienteId});
      } else if (value.error) {
        const error = value.error.error;
        let message="Ha ocurrido un error al actualizar";
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    'client.json'(newValue){
      if(this.isJson(newValue)){
      this.client.json= JSON.stringify(
            JSON.parse(newValue),
            null,
            3
          );
        }
    }
  },
  mounted() {
    this.clienteId=this.$route.params.id;
    if(this.clienteId){
      this.$store.commit("customer/getById",this.$route.params.id);
    }

  },
  methods: {
    save(){
      let form= this.$refs.editForm;
      if (form.checkValidity()) {
        if(!this.clienteId || this.clienteId==''){
          this.$store.commit("customer/createClient",this.client.json);
        }
        else{
          this.$store.commit("customer/updateClient",{body:this.client.json, id: this.clienteId});
        }
      }
      form.classList.add('was-validated');
    },
    closeNotificationAndRedirect(){
      const self= this;
      setTimeout(function () {
          self.showNotification=false
          if(this.clienteId){
            self.$router.push({ path: "/Administration/Brands/EditBrand/"+ this.clienteId});
          }
      }, 1050);
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification=false
      },2500);
    },
    loadStatusNotification(value){
        if (value.status == 'KO') {
          this.notificationInfo = {
            title: 'Ups! Lo Sentimos',
            message: value.error,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
        } else {
          this.notificationInfo = {
            title: 'Genial!',
            message: 'Su petición ha sido procesada',
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotification();
        }
    },
    isJson(val) {
            try {
                JSON.parse(val);
            } catch (e) {
                return false;
            }
            return true;
        }
  },
};
</script>

<style lang="scss" scoped>

.noimageColorEdit{ 
  opacity: 0.1 !important;  
}

.back-button {
  color: #4A7062
}
.btn-form {
  margin-bottom: 0rem;
}

.card-height {
  max-height: 31.3rem !important;
}
</style>
